import React from 'react';
import { CSVLink } from 'react-csv';
import { csvPriceRowType } from '../../utils/appConstants';
import { csvIncomeHeaders, csvExpenseHeaders } from './headers';
import CSVIcon from '../../assets/images/csv-file-icon.svg';

interface CSVProps {
    type: 'income' | 'expense',
    data: any,
    disabled?: boolean,
}

const CSVComponent: React.FC<CSVProps> = ({
  type, data, disabled,
}) => {
  if (disabled || !data || data.length <= 0) {
    return null;
  }

  const headers = (type === 'income') ? csvIncomeHeaders : csvExpenseHeaders;
  return (
    <CSVLink
      filename={`${type}_invoice.csv`}
      data={data}
      headers={headers}
      target="_blank"
      className={`csv-button ${type}`}
    >
      <span>{type.toUpperCase()}</span>
      <img src={CSVIcon} alt="CSV Download" width="30" />
    </CSVLink>
  );
};

export default CSVComponent;
